import { useEffect, useState } from "react";

import { ReportsService } from "../../services/ReportsService";
import "../Reports/styleReports.scss";
import { ReportViewer } from "./Report";

export default function ReportPage() {
  //const[report, setReport] = useState({})

  const [reportConfig, setReportConfig] = useState();

  useEffect(() => {
    ReportsService.get().then((data) => setReportConfig(data));
  }, []);

  return reportConfig ? <ReportViewer config={reportConfig} /> : null;
}
